import {
  loadStripe,
  Stripe,
  StripeCardElement,
  StripeElements,
} from '@stripe/stripe-js';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

type Props = {
  stripePublishableKey: string;
  className?: string;
  onError?: (message: string) => void;
  onReady?: (stripe: Stripe, elements: StripeElements) => void;
};

export type Ref = {
  stripe: Stripe | null;
  card: StripeCardElement | null;
};

const StripeCCInput = forwardRef<Ref, Props>(
  ({ stripePublishableKey, className, onReady }, ref) => {
    const [stripe, setStripe] = useState<Stripe | null>(null);
    const [card, setCard] = useState<StripeCardElement | null>(null);

    useEffect(() => {
      const setupStripe = async () => {
        const stripeInstance = await loadStripe(stripePublishableKey);
        const elements = stripeInstance?.elements();
        const cardElement = elements?.create('card');

        if (cardElement && stripeInstance && elements) {
          cardElement.mount('#card-element');
          setCard(cardElement);
          setStripe(stripeInstance);
          onReady?.(stripeInstance, elements);
        }
      };
      setupStripe();

      return () => {
        card?.destroy();
      };
    }, [stripePublishableKey]);

    useImperativeHandle(ref, () => ({
      stripe,
      card,
    }));

    return <div className={className} id="card-element"></div>;
  },
);

export default StripeCCInput;
